export default __webpack_public_path__ + "static/media/madame_detail13.40443c78.jpg";